var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("payment-qr")))]),
      _c(
        "w-card-content",
        [
          !_vm.hasValidBanks
            ? _c(
                "w-row",
                [
                  _c("w-col", [
                    _c("div", { staticClass: "disabled-reason" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$ct(
                            "to-use-this-function-you-have-to-have-at-least-one-bank-with-a-iban-and-bic-number"
                          )
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.settings.Show,
                      label: _vm.$ct("show"),
                      disabled: !_vm.hasValidBanks && !_vm.settings.Show,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.toggleShow($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-bank-type", {
                    attrs: {
                      "filter-only-with-iban": "",
                      disabled: _vm.disabled,
                      "use-ids": "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.settings.BankID,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "BankID", $$v)
                      },
                      expression: "settings.BankID",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }